module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goMessageList
    }
  }, [_vm._v("戻る")])])]), (_vm.searchCallbackFlag) ? _c('div', {
    staticClass: "container user-post-detail -no-bg-img"
  }, [_c('div', {
    staticClass: "user-post-detail__head"
  }, [_c('div', {
    staticClass: "user-outline mb15"
  }, [_c('div', {
    staticClass: "user-outline__img"
  }, [(_vm.messageDetail.attributes['profile-image-path']) ? _c('img', {
    attrs: {
      "src": _vm.messageDetail.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  }) : _c('img', {
    attrs: {
      "src": require("../images/img_profile.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "user-outline__body"
  }, [_c('p', {
    staticClass: "user-outline__body__role"
  }, [_vm._v(_vm._s(_vm.messageDetail.attributes['shop-name']) + " " + _vm._s(_vm.messageDetail.attributes['user-type-name']))]), _c('h3', {
    staticClass: "user-outline__body__name"
  }, [_vm._v(_vm._s(_vm.messageDetail.attributes['user-name']) + " " + _vm._s(_vm.messageDetail.attributes['user-firstname']))])])])]), _c('div', {
    staticClass: "user-post-detail__body",
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_c('p', {
    staticClass: "user-post-detail__body__time fz12 brown"
  }, [_vm._v(_vm._s(_vm.messageDetail.attributes['created-at-format']))]), _c('div', {
    staticClass: "user-post-detail__body__contents"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.content(_vm.messageDetail.attributes['content']))
    }
  })])])]) : _vm._e(), (_vm.isShopMaster && _vm.searchCallbackFlag) ? _c('div', {
    staticClass: "container user-post-detail -no-bg-img reply-section"
  }, [(!_vm.messageDetail.attributes['replyed-at']) ? _c('div', {
    staticClass: "reply-form"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replyMessage),
      expression: "replyMessage"
    }],
    staticClass: "reply-textarea",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "padding": "8px"
    },
    attrs: {
      "placeholder": "返信内容を入力してください",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.replyMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replyMessage = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "reply-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-lg",
    on: {
      "click": _vm.sendReply
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("返信メッセージを送信 ")]), _c('i', {
    staticClass: "fa fa-send",
    staticStyle: {
      "color": "white"
    }
  })])]), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("※メッセージの送信は1回のみです。メッセージのやり取りはできません。")])]) : _c('div', {
    staticClass: "reply-status"
  }, [_c('p', [_vm._v(_vm._s(_vm.messageDetail.attributes['replyed-at-format']) + " 返信済み")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36dc4b2a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/message-detail.pug
// module id = 1390
// module chunks = 1